(function () {
  const THRESHOLD_8000 = 8000;
  const THRESHOLD_12000 = 12000;

  const GIFT_8000 = "52080993173832";
  const GIFT_12000 = ["52080974856520", "52080987406664"];

  const ORIGINAL_FETCH = window.fetch.bind(window);

  /* --------------------------------------------------
    GLOBAL REFRESH HANDLER
  -------------------------------------------------- */
  function refreshQuickCartUI() {
    if (window.theme && typeof window.theme.refreshQuickCart === "function") {
      window.theme.refreshQuickCart();
    }
  }

  /* --------------------------------------------------
    GET CURRENT SUBTOTAL (subtract gift prices)
  -------------------------------------------------- */
  async function getCartSubtotal() {
    const cart = await ORIGINAL_FETCH("/cart.js", {
      credentials: "same-origin"
    }).then(r => r.json());

    let subtotal = cart.items_subtotal_price; // ALWAYS in cents

    // // Helper: get item by variant id
    // const getItem = (id) =>
    //   cart.items.find(x => String(x.variant_id) === String(id));

    // // Subtract price helper
    // function subtractGiftPrice(variantId) {
    //   const item = getItem(variantId);
    //   if (!item) return;

    //   subtotal -= item.final_line_price; // already price * quantity in cents
    // }

    // // ----- Apply conditional subtraction -----
    // if (subtotal >= THRESHOLD_12000) {
    //   subtractGiftPrice(GIFT_12000[0]);
    //   subtractGiftPrice(GIFT_12000[1]);
    // } else if (subtotal >= THRESHOLD_8000) {
    //   // Subtract 8k gift value (only if needed)
    //   subtractGiftPrice(GIFT_8000);
    // }

    return Math.max(subtotal, 0);
  }

  /* --------------------------------------------------
    HELPERS TO GET CART ITEM KEY
  -------------------------------------------------- */
  function getCartItemKey(variantId) {
    const item = document.querySelector(
      `.quick-cart__item[data-id="${variantId}"]`
    );
    return item ? item.getAttribute("data-key") : null;
  }

  /* --------------------------------------------------
    ADD ITEM
  -------------------------------------------------- */
  function addToCart(variantId) {
    return ORIGINAL_FETCH("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((r) => r.json())
      .finally(refreshQuickCartUI);
  }

  /* --------------------------------------------------
    REMOVE ITEM
  -------------------------------------------------- */
  function removeFromCart(itemKey) {
    if (!itemKey) return Promise.resolve();

    return ORIGINAL_FETCH("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: itemKey, quantity: 0 }),
    })
      .then((r) => {
        r.json();
      })
      .finally(refreshQuickCartUI);
  }

  /* --------------------------------------------------
    FORCE GIFT QUANTITY = 1
  -------------------------------------------------- */
  function fixGiftQuantity(variantId) {
    const item = document.querySelector(
      `.quick-cart__item[data-id="${variantId}"]`
    );
    if (!item) return;

    const key = item.getAttribute("data-key");
    if (!key) return;

    const qtyEl = item.querySelector(".quick-cart__item-qty input");
    if (!qtyEl) return;

    const current = parseInt(qtyEl.value, 10);
    if (current === 1) return;

    ORIGINAL_FETCH("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: 1 }),
    })
      .finally(refreshQuickCartUI)
      .catch(console.error);
  }

  /* --------------------------------------------------
    MAIN SYNC LOGIC
  -------------------------------------------------- */
  async function syncGifts() {
    const subtotal = await getCartSubtotal();

    const gift8000Key = getCartItemKey(GIFT_8000);
    const gift12000Keys = GIFT_12000.map(getCartItemKey);

    /* -----------------------------------
      TIER: 12000+
      ----------------------------------- */
    if (subtotal >= THRESHOLD_12000) {

      // ALWAYS remove the 8000-tier gift
      if (gift8000Key) {
        await removeFromCart(gift8000Key);
      }

      // Ensure 12000-tier gifts are present
      for (let i = 0; i < GIFT_12000.length; i++) {
        const variantId = GIFT_12000[i];
        const key = gift12000Keys[i];

        if (!key) {
          await addToCart(variantId);
        } else {
          fixGiftQuantity(variantId);
        }
      }

      refreshQuickCartUI();
      return;
    }

    /* -----------------------------------
      TIER: 8000–11999
      ----------------------------------- */
    if (subtotal >= THRESHOLD_8000) {

      // Remove 12000-tier gifts if present
      for (let i = 0; i < GIFT_12000.length; i++) {
        const key = gift12000Keys[i];
        if (key) await removeFromCart(key);
      }

      // Add/ensure ONLY the 8000-tier gift
      if (!gift8000Key) {
        await addToCart(GIFT_8000);
      } else {
        fixGiftQuantity(GIFT_8000);
      }

      refreshQuickCartUI();
      return;
    }

    /* -----------------------------------
      BELOW 8000
      Remove ALL gifts
      ----------------------------------- */
    if (gift8000Key) await removeFromCart(gift8000Key);

    for (let i = 0; i < GIFT_12000.length; i++) {
      const key = gift12000Keys[i];
      if (key) await removeFromCart(key);
    }

    // refreshQuickCartUI();
  }


  /* --------------------------------------------------
    PATCH FETCH TO DETECT CART MUTATIONS
  -------------------------------------------------- */
  (function patchFetchForCart() {
    if (!window.fetch || window.fetch.__autoGiftPatched) return;

    window.fetch = function (input, init) {
      const url = typeof input === "string" ? input : input?.url;
      const isCartMutation =
        url && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url);

      const result = ORIGINAL_FETCH(input, init);

      if (isCartMutation) {
        result
          .then((res) => {
            setTimeout(() => {
              syncGifts();
            }, 2000);

            refreshQuickCartUI();
            return res;
          })
          .catch((err) => console.error("Cart mutation failed:", err));
      }

      return result;
    };

    window.fetch.__autoGiftPatched = true;
  })();

  /* --------------------------------------------------
    INITIAL RUN
  -------------------------------------------------- */
  document.addEventListener("DOMContentLoaded", syncGifts);
})();
